import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SmartImg from "@/lib/img";

export default function Worship() {
  return (
    <section id="worship" data-testid="worship-section" className="py-32 md:py-48 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase text-gold mb-4">Worship & Learning</p>
            <h2 className="font-syne font-bold uppercase tracking-tighter leading-[0.95] text-4xl md:text-6xl mb-8">
              Pray. Learn. <span className="text-gold">Belong.</span>
            </h2>
            <p className="text-base md:text-lg text-foreground/70 leading-relaxed max-w-xl">
              Inspiring Shabbat and holiday services — in person in our sanctuary and livestreamed wherever you are.
              Torah study, Hebrew lessons and conversion classes welcome every level of learner.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="mt-12 space-y-0">
            {[
              { label: "Kabbalat Shabbat — Friday Evenings", meta: "7:00 PM · In person & livestreamed", href: "/live" },
              { label: "Shabbat Morning Service", meta: "Saturdays 9:30 AM · In person & livestreamed", href: "/live" },
              { label: "Sunday Morning Minyan", meta: "Sundays 9:00 AM · In person", href: "/live" },
              { label: "Lifelong Learning", meta: "Adult ed · Hebrew · Conversion classes", href: "/learning" },
            ].map((r) => (
              <a
                key={r.label}
                href={r.href}
                target={r.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                data-testid={`worship-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex items-center justify-between border-b border-white/10 py-6 hover:border-gold/50 transition-colors duration-500 cursor-pointer"
              >
                <div>
                  <h3 className="font-syne font-bold uppercase tracking-tight text-lg md:text-xl">{r.label}</h3>
                  <p className="text-sm text-foreground/50 mt-1">{r.meta}</p>
                </div>
                <ArrowUpRight size={20} className="text-gold transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            ))}
          </Reveal>

          <Reveal delay={0.25} className="mt-10">
            <a
              data-testid="worship-livestream-button"
              href="/live"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 border border-gold/60 text-gold text-xs tracking-[0.25em] uppercase hover:bg-gold hover:text-inkdeep transition-colors duration-400"
            >
              Watch the Livestream
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:col-span-6">
          <a
            data-testid="worship-hhd-card"
            href="https://templebethelwpb.shulcloud.com/hhd5787"
            target="_blank"
            rel="noopener noreferrer"
            className="group block overflow-hidden border border-white/10 hover:border-gold/60 transition-colors duration-500"
          >
            <div className="overflow-hidden">
              <SmartImg
                src="/img/firstparty/tbehhd5787slider.webp"
                sizes="(max-width: 768px) 100vw, 50vw"
                alt="High Holy Days 5787 at Beth El Center for Jewish Life"
                loading="lazy"
                decoding="async"
                className="w-full aspect-[16/10] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
            </div>
            <div className="p-6 md:p-8 flex items-center justify-between">
              <div>
                <p className="text-[10px] tracking-[0.3em] uppercase text-gold mb-2">Reserve Your Seat</p>
                <h3 className="font-syne font-bold uppercase tracking-tight text-xl md:text-2xl">High Holy Days 5787</h3>
              </div>
              <ArrowUpRight size={24} className="text-gold transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
